<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <logo />
        </b-link>

        <b-card-title class="mb-1 text-center">
          {{ t('Reset Password') }}
        </b-card-title>

        <!--Login form -->
        <validation-observer ref="forgotPasswordForm">
          <b-form
            ref="forgotPasswordFormElement"
            class="auth-login-form mt-2"
            @submit.prevent="forgotPassword"
          >
            <!-- email -->
            <b-form-group label-for="Email" :label="t('Email')">
              <validation-provider #default="{ errors }" :name="t('Email')" rules="required|email">
                <b-form-input
                  id="email"
                  v-model="emailValue"
                  name="email"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="t('Email')"
                  tabindex="1"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button variant="primary" type="submit" block :disabled="submitting">
              {{ submitting ? t('Loading') : t('Send Reset Email') }}
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle } from 'bootstrap-vue';
import Logo from '@core/layouts/components/Logo.vue';
import { required, email } from '@validations';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us';

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    Logo,
    ValidationProvider,
    ValidationObserver
  },

  mixins: [helper],

  data() {
    return {
      emailValue: '',

      // validation rules
      required,
      email,
      submitting: false
    };
  },
  computed: {},

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  },

  methods: {
    forgotPassword() {
      this.$refs.forgotPasswordForm.validate().then(success => {
        if (success) {
          this.submitting = true;

          useService
            .forgotPassword({
              email: this.emailValue
            })
            .then(response => {
              this.$refs.forgotPasswordFormElement.reset();
              this.showSuccessMessage(
                `${response.message || this.$t('Forgot Password Email Sent')}`
              );
            })
            .catch(messages => {
              if (typeof messages === 'object' && messages && messages.length) {
                messages.forEach(item => {
                  this.showErrorMessage(item.message);
                });
              }
            })
            .finally(() => {
              this.submitting = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
